<template>
    <div class="wrapper">
        <loading v-if="isBusy"></loading>
        <div class="row" v-else-if="hasData">
            <div class="col-6">
                <p class="el-style attribute-name">Contact's message:</p>
                <p class="message-content">{{ contactMessage }}</p>
            </div>
            <div class="col-6">
                <p class="el-style attribute-name">Staff's message:</p>
                <p class="message-content">{{ staffMessage }}</p>
            </div>
        </div>
    </div>
</template>

<script>
  import Loading from '../../components/loading';
  import AjaxErrorHandler from '../../mixins/ajax-errors';

  export default {
    components: {
      Loading,
    },

    mixins: [
      AjaxErrorHandler
    ],

    props: [
      'row',
    ],

    data() {
      return {
        isBusy: false,
        data: null,
      };
    },

    computed: {
      /**
       * @return {boolean}
       */
      hasData() {
        return Boolean(this.data);
      },

      /**
       * @return {string}
       */
      url() {
        return _.get(this.row, 'show_url');
      },

      /**
       * @return {string}
       */
      contactMessage() {
        return _.get(this.data, 'contact_message.content', '-');
      },

      /**
       * @return {string}
       */
      staffMessage() {
        return _.get(this.data, 'staff_message.content', '-');
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      performLoading() {
        this.isBusy = true;
        axios.get(this.url)
          .then(this.onLoadSuccess)
          .catch(this.onLoadError)
          .then(() => {
            this.isBusy = false;
          });
      },

      /**
       * @param {Object} data
       * @return {undefined}
       */
      onLoadSuccess({data: {data}}) {
        this.data = data;
      },

      /**
       * @param {Object} error
       * @return {undefined}
       */
      onLoadError(error) {
        this.handleErrorResponse(error);
      },
    },

    mounted() {
      this.performLoading();
    }
  }
</script>
